import { render } from "./bulletins-list.vue?vue&type=template&id=226741b0&scoped=true"
import script from "./bulletins-list.vue?vue&type=script&lang=js"
export * from "./bulletins-list.vue?vue&type=script&lang=js"

import "./bulletins-list.vue?vue&type=style&index=0&id=226741b0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-226741b0"]])

export default __exports__